import { SolicitacaoArquivosService } from './../solicitacao-arquivos.service';
import { LabelTipoSolicitacaoArquivo, SolicitacaoArquivos, TipoSolicitacaoArquivos } from './../../../model/solicitacao-arquivos.model';
import { Component, OnInit, HostListener } from "@angular/core";
import { DatePipe } from '@angular/common';
import { EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";


@Component({
    selector: 'app-solicitacao-arquivos-pesquisa',
    templateUrl: './solicitacao-arquivos.pesquisa.component.html',
    styleUrls: ['./solicitacao-arquivos.pesquisa.scss'],
    standalone: false
})
export class SolicitacaoArquivosPesquisaComponent implements OnInit {

  public arquivo: SolicitacaoArquivos[];
  public tipoSolicitacao: TipoSolicitacaoArquivos[];
  public cnpjAgenteFinanceiro: string;
  public codigoTipoSolicitacao: string;
  public dataInicio: Date;
  public dataFim: Date;
  public pesquisado: boolean = false;
  public atributosPaginacaoComponenteListagem: EntityPagedResult<SolicitacaoArquivos>;
  public opcoesPaginacao: number[];
  public formatoArquivo: string;

  constructor(private solicitacaoArquivosService: SolicitacaoArquivosService,
              private datePipe: DatePipe){

  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar()
  }

  ngOnInit(): void {

    this.buscarTipos();

    this.opcoesPaginacao = [10, 20, 30];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };
  }

  public mudancaPagina(novaPagina: EntityPagedResult<SolicitacaoArquivos>) {

    this.atributosPaginacaoComponenteListagem = novaPagina;
  }

  public buscar() {
    this.pesquisado = false;
    let dto: any = {};
    if(this.cnpjAgenteFinanceiro) {
      dto.cnpjAgenteFinanceiro = this.cnpjAgenteFinanceiro;
    }
    if(this.codigoTipoSolicitacao) {
      dto.codigoTipoSolicitacao = this.codigoTipoSolicitacao;
    }
    if(this.dataInicio) {
      dto.dataSolicitacaoIni = this.datePipe.transform(this.dataInicio, 'yyyyMMdd');
    }
    if(this.dataFim) {
      dto.dataSolicitacaoFim = this.datePipe.transform(this.dataFim, 'yyyyMMdd');
    }
    this.solicitacaoArquivosService.buscarPorFiltro(dto).subscribe((arquivos: any) => {
      this.arquivo = arquivos;
      this.pesquisado = true;
    })
  }

  public buscarTipos() {
    this.solicitacaoArquivosService.buscarTiposSolicitacaoArquivo().subscribe((tipos: TipoSolicitacaoArquivos[]) => {
      this.tipoSolicitacao = tipos;
    })
  }

  public limpar() {

    this.cnpjAgenteFinanceiro = null;
    this.codigoTipoSolicitacao = null;
    this.dataInicio = null;
    this.dataFim = null;
    this.pesquisado = false;
  }
}
